// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const resetSpecialAllowanceClaimStatusReport = () => ({
    type: actions.RESET_SPECIAL_ALLOWANCE_CLAIM_STATUS_REPORT
});

export const selectOriginalSubmissionDate = originalSubmissionDate => ({
    originalSubmissionDate,
    type: actions.SELECT_ORIGINAL_SUBMISSION_DATE
});

export const selectSpecialAllowanceClaimStatusTerritory = (isSelected, territory) => ({
    isSelected,
    territory,
    type: actions.SELECT_SPECIAL_ALLOWANCE_CLAIM_STATUS_TERRITORY
});

export const selectAllTerritories = territories => ({
    territories,
    type: actions.SELECT_ALL_SPECIAL_ALLOWANCE_CLAIM_STATUS_TERRITORIES
});



// WEBPACK FOOTER //
// ./src/reports/special-allowance-claim-status/action-creators/criteria.js